import { companyInfo, navLinks } from '@/mocks/multifierros';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-300/40">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-10 md:py-14">
        {/* Nav links */}
        <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mb-6">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className="text-foreground-300 hover:text-foreground-50 text-xs font-medium uppercase tracking-wider transition-colors whitespace-nowrap"
              >
                {link.label}
              </a>
            </li>
          ))}
          <li>
            <a
              href="#contacto"
              className="text-foreground-300 hover:text-foreground-50 text-xs font-medium uppercase tracking-wider transition-colors whitespace-nowrap"
            >
              Cotización
            </a>
          </li>
        </ul>

        {/* Contact info */}
        <div className="text-center mb-6">
          <p className="text-foreground-300 text-xs flex items-center justify-center gap-1.5 flex-wrap">
            <i className="ri-map-pin-line text-xs"></i>
            {companyInfo.address}, {companyInfo.city}, {companyInfo.country}
          </p>
          <p className="text-foreground-300 text-xs mt-1">
            <a
              href={`tel:${companyInfo.phones[0].replace(/\s/g, '')}`}
              className="hover:text-foreground-50 transition-colors flex items-center justify-center gap-1.5"
            >
              <i className="ri-phone-line text-xs"></i>
              {companyInfo.phones[0]}
            </a>
          </p>
        </div>

        {/* Bottom */}
        <div className="border-t border-background-300/40 pt-5 flex flex-col sm:flex-row items-center justify-center gap-3">
          <p className="text-foreground-400 text-xs">
            &copy; {year} {companyInfo.name} · Todos los derechos reservados
          </p>
        </div>
      </div>
    </footer>
  );
}